import Spin from "components/_spin"
import { ButtonHTMLAttributes, DetailedHTMLProps, FC, memo, ReactNode } from "react"
import styles from "./index.module.scss"


type btnType = "secondry" | "bordered" | "ghost"

interface IProps extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
> {
    children: ReactNode
    loading?: boolean
    className?: string
    deactive?: boolean
    backBtn?: boolean
    btnType?: btnType
    animation?: boolean
}


const Button: FC<IProps> = ({ children, loading = false, className, btnType, deactive, backBtn, animation, ...props }) => {
    return (
        <button
            {...props}
            disabled={loading || (props?.disabled ?? false)}
            className={styles.button + ` flex flex-row align-i-center btn ${btnType ? styles[btnType] : ''} ${animation ? styles.animation : ''} ${deactive ? styles.deactive : ""} ${backBtn ? styles.back : ""} ${className ?? ""}`}
        >
            {
                loading ?
                    <span className="flex flex-grow jcc"><Spin color={deactive && "#fff"} size={17} /></span>
                    :
                    children
            }
        </button>
    )
}

export default memo(Button)